import '../styles/Footer.css';
const Footer = () => {

  return (
    <footer>
      Instituto Universitario Tecnológico Del Azuay
      ||
      <strong>
        Contáctanos: Dirección: Octavio Chacón Moscoso 1-98 y Primera Transversal (Parque industrial) |
        Teléfono: 07 2809 551 - 0995363076 |
        Correo Electrónico: info@tecazuay.edu.ec
      </strong>
    </footer>
  );
};

export default Footer;
